export const THEMES = {
  DARK: 'dark',
  DEFAULT: 'os',
  LIGHT: 'light',
} as const;
